<div class="component-wrapper">
  <div id="label">
    {{label}}
    @if (hasValidtor('require')) {
      <span class="reqIcon" id="require" #require > * </span>
    }
    @if (hasValidtor('info')) {
      <span id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info'}"> ? </span>
    }
  </div>
  <div class="slider">
    <div class="sliderContainer"></div>
    <div class="statesContainer">
      @for (state of stateCasted; track state; let first = $first; let last = $last) {
        <div class="stateWrapper"
          [class.selected]="state.value === valueCasted" [class.first] = "first" [class.last] = "last"
          (click)="switchState(state.value)">
          <div class="sliderState"
            [class.colored]="state.value <= valueCasted"
          [class.selected]="state.value === valueCasted"></div>
          <div class="stateLabel" [class.selected]="state.value === valueCasted">{{state.displayValue}}</div>
        </div>
      }
    </div>
  </div>
</div>

